const eng = () => {
    return {
        share: "Share",
        share_book_title: "Share MeBook"
    };
};

export default eng;
